import { LoginComponent } from './pages/login/login.component';
import { ReportingComponent } from './pages/reporting/reporting.component';
import { NgModule, ViewRef } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './_guards/auth.guard';
import { ViewReloadComponent } from './pages/view-reload/view-reload.component';
import { PasswordResetComponent } from './pages/password-reset/password-reset.component';

const routes: Routes = [
  { path: '', redirectTo: '/reporting', pathMatch: 'full' },
  { path: 'reporting', component: ReportingComponent, canActivate: [AuthGuard], runGuardsAndResolvers: 'always' },
  { path: 'viewReload', component: ViewReloadComponent, canActivate: [AuthGuard], runGuardsAndResolvers: 'always' },
  { path: 'login', component: LoginComponent },
  { path: 'passwordReset', component: PasswordResetComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
